import React from "react";
import "./Aboutus2.css";
import { useLanguage } from "../LanguageContext";

const AboutUsVision2 = () => {
  const { language } = useLanguage();

  return (
    <div className="about-partners">
      <div className="about-sections-container">
        <div className="about-section">
          <h2 className="about-subtitle">Mission</h2>
          <p className="about-text">
            {language === "en" ? (
              <>We are committed to:</>
            ) : (
              <>เรามุ่งมั่นในการทำสิ่งต่อไปนี้:</>
            )}
          </p>
        </div>

        <div className="about-section">
          <p className="about-text">
            {language === "en" ? (
              <>
                <b>1. Empowering People</b>
                <br />
                By cultivating a culture of learning, ownership, and innovation.
              </>
            ) : (
              <>
                <b>1. พัฒนาคนของเรา</b>
                <br />
                ผ่านการสร้างวัฒนธรรมการเรียนรู้ ความรับผิดชอบ
                และนวัตกรรมภายในทีม
              </>
            )}
          </p>
        </div>

        <div className="about-section">
          <p className="about-text">
            {language === "en" ? (
              <>
                <b>2. Delivering Excellence</b>
                <br />
                Through reliable, value-driven IT solutions tailored to real
                business needs.
              </>
            ) : (
              <>
                <b>2. ส่งมอบงานอย่างเป็นเลิศ</b>
                <br />
                ด้วยโซลูชันที่ตอบโจทย์จริง มีคุณค่า
                และใช้งานได้จริงในแต่ละองค์กร
              </>
            )}
          </p>
        </div>

        <div className="about-section">
          <p className="about-text">
            {language === "en" ? (
              <>
                <b>3. Building Trusted Relationships</b>
                <br />
                By working with integrity, transparency, and respect.
              </>
            ) : (
              <>
                <b>3. สร้างความสัมพันธ์ที่ไว้วางใจได้</b>
                <br />
                ผ่านการทำงานด้วยความซื่อสัตย์ โปร่งใส และให้ความเคารพต่อกัน
              </>
            )}
          </p>
        </div>

        <div className="about-section">
          <p className="about-text">
            {language === "en" ? (
              <>
                <b>4. Simplifying Technology</b>
                <br />
                To help our clients work smarter, grow faster, and achieve more
                with less.
              </>
            ) : (
              <>
                <b>4. ทำให้เทคโนโลยีเรียบง่าย</b>
                <br />
                เพื่อให้ลูกค้าทำงานได้อย่างชาญฉลาด เติบโตเร็วขึ้น
                และใช้ทรัพยากรได้อย่างคุ้มค่า
              </>
            )}
          </p>
        </div>
        <br />
        <br />

        <div className="about-section">
          <h2 className="about-subtitle">
            {language === "en" ? "Core Values" : "ค่านิยมหลัก"}
          </h2>
          <table className="core-values-table">
            <thead>
              <tr>
                <th>{language === "en" ? "Value" : "คำนิยม"}</th>
                <th>{language === "en" ? "Description" : "ความหมาย"}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {language === "en"
                    ? "Integrity"
                    : "ความซื่อสัตย์ (Integrity)"}
                </td>
                <td>
                  {language === "en"
                    ? "We do what’s right — not what’s easy."
                    : "เราทำในสิ่งที่ถูกต้อง แม้ไม่ใช่ทางที่ง่ายที่สุด"}
                </td>
              </tr>
              <tr>
                <td> {language === "en" ? "Growth" : "การเติบโต (Growth)"}</td>
                <td>
                  {language === "en"
                    ? "We never stop learning or improving."
                    : "เราไม่หยุดเรียนรู้ พัฒนา และปรับตัวอยู่เสมอ"}
                </td>
              </tr>
              <tr>
                <td>
                  {" "}
                  {language === "en"
                    ? "Collaboration"
                    : "การร่วมมือ (Collaboration)"}
                </td>
                <td>
                  {language === "en"
                    ? "We believe in teamwork, both within our company and with our clients."
                    : "เราเชื่อในพลังของการทำงานเป็นทีม ทั้งภายในและกับลูกค้า"}
                </td>
              </tr>
              <tr>
                <td>
                  {" "}
                  {language === "en" ? "Humble" : "ความอ่อนน้อมถ่อมตน (Humble)"}
                </td>
                <td>
                  {language === "en"
                    ? "We stay grounded, open-minded, and put others before ego."
                    : "เราเปิดใจ รับฟัง และให้ความสำคัญกับผู้อื่นมากกว่าตัวเราเอง"}
                </td>
              </tr>
              <tr>
                <td>
                  {" "}
                  {language === "en"
                    ? "Accountability"
                    : "ความรับผิดชอบ (Accountability)"}
                </td>

                <td>
                  {language === "en"
                    ? "We take full responsibility for our work and results."
                    : "เรารับผิดชอบต่อผลงานและผลลัพธ์ที่เกิดขึ้นอย่างเต็มที่"}
                </td>
              </tr>
              <tr>
                <td>
                  {" "}
                  {language === "en"
                    ? "Adaptability"
                    : "ความหยืดหยุ่น (Adaptability)"}
                </td>
                <td>
                  {language === "en"
                    ? "We stay agile in a world that never stops changing."
                    : "เราปรับตัวได้ดีในโลกที่เปลี่ยนแปลงอย่างรวดเร็ว"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AboutUsVision2;
